import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import AssignTargetForm from './form'

function AssignTargetDialog ({ open, onClose, job }) {
  return (
    <SydModal
      open={open}
      onClose={onClose}
      title='Assign to Provisioned Target'
      size='large'
    >
      {open ? (
        <AssignTargetForm job={job} onCancel={onClose} />
      ) : null}
    </SydModal>
  )
}

AssignTargetDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  job: PropTypes.object
}

export default AssignTargetDialog
